import { useAppSelector } from '../../../hooks/redux';
import { LoadGrowthPromptData } from './LoadGrowthPromptData';
import { selectGates } from '../../../reducers/Portal';
import { jsx as _jsx } from "react/jsx-runtime";
export const MaybeLoadGrowthPromptsNavigationComponent = () => {
  const gates = useAppSelector(selectGates);
  const isUngatedToGrowthPromptsNC = gates && gates.includes('Growth:OnboardingUsage:GrowthPromptsNavigationComponents');
  if (!isUngatedToGrowthPromptsNC) {
    return null;
  }
  return /*#__PURE__*/_jsx(LoadGrowthPromptData, {});
};